import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { CoreCustomFormsFieldArtworkLinkSelectorV1FieldsModule } from './artwork-link-selector-v1/artwork-link-selector-v1-fields.module';
// import { CoreCustomFormsFieldCodeGeneratorV1FieldsModule } from './code-generator-v1/code-generator-v1-fields.module';
import { CoreCustomFormsFieldDateV1FieldsModule } from './date-v1/date-v1-fields.module';
import { CoreCustomFormsFieldDropdownSelectorV1FieldsModule } from './dropdown-selector-v1/dropdown-selector-v1-fields.module';
import { CoreCustomFormsFieldEmailTextV1FieldsModule } from './email-text-v1/email-text-v1-fields.module';
import { CoreCustomFormsFieldFilesV1FieldsModule } from './files-v1/files-v1-fields.module';
import { CoreCustomFormsFieldMultipleChoiceV1FieldsModule } from './multiple-choice-v1/multiple-choice-v1-fields.module';
import { CoreCustomFormsFieldMultipleTagSelectorV1FieldsModule } from './multiple-tag-selector-v1/multiple-tag-selector-v1-fields.module';
import { CoreCustomFormsFieldNumberTextV1FieldsModule } from './number-text-v1/number-text-v1-fields.module';
import { CoreCustomFormsFieldRichTextV1FieldsModule } from './rich-text-v1/rich-text-v1-fields.module';
import { CoreCustomFormsFieldShortTextV1FieldsModule } from './short-text-v1/short-text-v1-fields.module';
import { CoreCustomFormsFieldSingleTagSelectorV1FieldsModule } from './single-tag-selector-v1/single-tag-selector-v1-fields.module';
import { CoreCustomFormsFieldUrlTextV1FieldsModule } from './url-text-v1/url-text-v1-fields.module';
import { CoreCustomFormsFieldUserSelectorV1FieldsModule } from './user-selector-v1/user-selector-v1-fields.module';

/**
 * @todo CoreCustomFormsFieldCodeGeneratorV1FieldsModule will be included after first release
 */
@NgModule({
    imports: [
        CoreCustomFormsFieldArtworkLinkSelectorV1FieldsModule,
        // CoreCustomFormsFieldCodeGeneratorV1FieldsModule,
        CoreCustomFormsFieldDateV1FieldsModule,
        CoreCustomFormsFieldDropdownSelectorV1FieldsModule,
        CoreCustomFormsFieldEmailTextV1FieldsModule,
        CoreCustomFormsFieldFilesV1FieldsModule,
        CoreCustomFormsFieldMultipleChoiceV1FieldsModule,
        CoreCustomFormsFieldMultipleTagSelectorV1FieldsModule,
        CoreCustomFormsFieldNumberTextV1FieldsModule,
        CoreCustomFormsFieldRichTextV1FieldsModule,
        CoreCustomFormsFieldShortTextV1FieldsModule,
        CoreCustomFormsFieldSingleTagSelectorV1FieldsModule,
        CoreCustomFormsFieldUrlTextV1FieldsModule,
        CoreCustomFormsFieldUserSelectorV1FieldsModule
        
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
    ],
    exports: [
        CoreCustomFormsFieldArtworkLinkSelectorV1FieldsModule,
        // CoreCustomFormsFieldCodeGeneratorV1FieldsModule,
        CoreCustomFormsFieldDateV1FieldsModule,
        CoreCustomFormsFieldDropdownSelectorV1FieldsModule,
        CoreCustomFormsFieldEmailTextV1FieldsModule,
        CoreCustomFormsFieldFilesV1FieldsModule,
        CoreCustomFormsFieldMultipleChoiceV1FieldsModule,
        CoreCustomFormsFieldMultipleTagSelectorV1FieldsModule,
        CoreCustomFormsFieldNumberTextV1FieldsModule,
        CoreCustomFormsFieldRichTextV1FieldsModule,
        CoreCustomFormsFieldShortTextV1FieldsModule,
        CoreCustomFormsFieldSingleTagSelectorV1FieldsModule,
        CoreCustomFormsFieldUrlTextV1FieldsModule,
        CoreCustomFormsFieldUserSelectorV1FieldsModule
    ],

})
export class CoreCustomFormsFieldComponentsModule { }
